<template>
  <!-- 天气 -->
  <div class="Others19Charts">
    <div class="weather-left" :class="getStyle('title')">
      <div class="w-l-top">
        <!-- 城市 -->
        <div class="cityname flex-t-b">
          <div class="title" :style="getWidthStyle(-10)">
            <span> {{ cityName }}</span>
          </div>
        </div>
        <!-- 天气 -->
        <div class="weather flex-t-b">
          <div class="title" :style="getWidthStyle(-12)">{{ weather }}</div>
        </div>
        <!-- 温度 -->
        <div class="temperature flex-t-b">
          <div class="title" :style="getWidthStyle(-10)">
            <span>温度</span>
            <span style="margin-left: 20px">{{ getNowTime(new Date(), 'normal') }}</span>
          </div>
        </div>
      </div>
      <div class="w-l-middle">
        <div class="weather">
          <weather-module class="img" :weatherType="weatherIcon"></weather-module>
        </div>
        <div
          class="tmp-num"
          :style="{
            fontSize: titleFontSize + 'px',
          }"
        >
          {{ temperature }} <span> ℃</span>
        </div>
      </div>
      <div class="w-l-bottom">
        <div class="border"></div>
        <div class="content">
          <!-- 降雨量 -->
          <div class="humidity flex">
            <div class="title" :style="getWidthStyle(-14)">
              <img src="@/assets/img/weather/jyl.png" alt="" />
            </div>
            <div class="data" :style="getWidthStyle(-12)">{{ rainfall }}毫米</div>
          </div>
          <!-- 风力风向 -->
          <div class="humidity flex">
            <div class="title" :style="getWidthStyle(-14)">
              <img src="@/assets/img/weather/fs.png" alt="" />
            </div>
            <div class="data" :style="getWidthStyle(-12)">{{ windpower }}/时</div>
          </div>
          <!-- 湿度 -->
          <div class="humidity flex">
            <div class="title" :style="getWidthStyle(-14)">
              <img src="@/assets/img/weather/sd.png" alt="" />
            </div>
            <div class="data" :style="getWidthStyle(-12)">{{ humidity }}%</div>
          </div>
          <div class="humidity flex">
            <div class="title" :style="getWidthStyle(-14)">
              <img src="@/assets/img/weather/uv.png" alt="" />
            </div>
            <div class="data" :style="getWidthStyle(-12)">{{ ultraviolet ? ultraviolet : 4 }}</div>
          </div>
        </div>
        <div class="border"></div>
      </div>
    </div>
    <div class="weather-right">
      <div class="seven-forecast" v-for="(item, index) in forecasts" :key="index">
        <div class="s-f-left">
          <div class="date">
            <div class="d-top" :style="getWidthStyle(-10)">{{ getNowTime(item.date, 'special')[0] }}</div>
            <div class="d-bottom" :style="getWidthStyle(-14)">{{ getNowTime(item.date, 'special')[1] }}</div>
          </div>
        </div>
        <div class="s-f-center">
          <div class="weather-img">
            <div>
              <i
                :style="{
                  fontSize: `${$w_Ratio(4 + getShowfontSizeBase(), $store)}px`,
                }"
                :class="['wi', getImgByWeather(item.weather), 'weather-icon-animate']"
              ></i>
            </div>
          </div>
        </div>
        <div class="s-f-right">
          <div class="weather-name" :style="getWidthStyle(-10)">{{ item.weather }}</div>
          <div class="tmp-max-min" :style="getWidthStyle(-14)">
            <span>{{ item.minTmp }}℃</span>
            ~
            <span>{{ item.maxTmp }}℃</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { request } from '../../../common/request';
import weatherModule from '@/components/common/weatherModule/weatherModule.vue';
import adcode from '@/components/common/weatherModule/adcode.json';
import jsonp from 'jsonp';
export default {
  name: 'Others19Charts',
  components: { weatherModule },
  props: {
    Configuration: Object,
    ProjectInfo: Object,
  },
  data() {
    return {
      style: {
        height: 72,
      },
      timeString: '',
      dateString: '',
      cityName: '',
      city: '',
      weather: '', // 当前天气
      temperature: '', // 当前温度
      humidity: '', // 湿度
      winddirection: '', // 风向
      windpower: '', // 风力
      aqi: 0, // 空气质量数值
      ultraviolet: '', // 紫外线强度
      pm2point5: '0', // PM2.5
      weatherIcon: '',
      rainfall: '',
      forecasts: [
        {
          weather: '多云',
          date: '2023-05-16',
          maxTmp: '30',
          minTmp: '21',
        },
        {
          weather: '阴',
          date: '2023-05-17',
          maxTmp: '33',
          minTmp: '23',
        },
        {
          text: '多云',
          date: '2023-05-18',
          high: '31',
          minTmp: '24',
        },
        {
          weather: '阵雨',
          date: '2023-05-19',
          maxTmp: '30',
          minTmp: '21',
        },
        {
          weather: '阵雨',
          date: '2023-05-20',
          maxTmp: '18',
          minTmp: '19',
        },
      ], // 未来的天气预报
      province: '',
      toggleBoolean: true,
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      headerLon: '',
      headerLat: '',
      params: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (val) {
        this.headerLon = val.propertyData.headerLngLatData.value.lon;
        this.headerLat = val.propertyData.headerLngLatData.value.lat;
      },
    },
    cityNameCopy(nV, oV) {
      if (nV) {
        this.onConfigurationChange();
      }
    },
  },
  created() {
    this.onConfigurationChange();
    this.autoGetTime();
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
  },
  computed: {
    titleFontSize() {
      return this.Configuration.propertyData.fontStyle.value.titleSize;
    },
    xFontSize() {
      return this.Configuration.propertyData.fontStyle.value.xAxisSize;
    },
    yFontSize() {
      return this.Configuration.propertyData.fontStyle.value.yAxisSize;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    this.headerLon = this.Configuration.propertyData?.headerLngLatData?.value?.lon;
    this.headerLat = this.Configuration.propertyData?.headerLngLatData?.value?.lat;

    this.cityName = this.Configuration.propertyData.cityName.value;

    this.getDynamicWeather();
    this.getWeeklyWeather();
    this.getDynamicDayWeather();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.unRegisterDebounceAndThrottle();
  },
  methods: {
    getStyle(e = '') {
      let style = {};
      switch (this.style) {
        case 'V1Style':
          style['V1' + e] = true;
          break;
        case 'V2Style':
          style['V2' + e] = true;
          break;
        case 'V3Style':
          style['V3' + e] = true;
          break;
        case 'V4Style':
          style['V4' + e] = true;
          break;
        case 'V5Style':
          style['V5' + e] = true;
          break;
        case 'V6Style':
          style['V6' + e] = true;
          break;
        case 'V7Style':
          style['V7' + e] = true;
          break;
        case 'V8Style':
          style['V8' + e] = true;
          break;
        case 'V9Style':
          style['V9' + e] = true;
          break;
        default:
          break;
      }
      return style;
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    // 获取时间
    getNowTime(time, flag) {
      let now = new Date(time);
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      let day = now.getDay(); // 得到周几
      month = month + 1;
      month = month.toString().padStart(2, '0');
      date = date.toString().padStart(2, '0');

      function getWeek(index, specialDeal = false) {
        let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        let result = '';
        if (specialDeal) {
          let currentDate = new Date().getDate().toString().padStart(2, '0');
          let tomorrow = new Date();
          tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
          let tomorrowDate = tomorrow.getDate().toString().padStart(2, '0');
          result = week[index];
          if (currentDate == date) {
            result = '今天';
          }
          if (tomorrowDate == date) {
            result = '明天';
          }
        } else {
          result = week[index];
        }
        return result;
      }

      if (flag == 'normal') {
        return `${getWeek(day)} ${year}-${month}-${date}`;
      }
      if (flag == 'special') {
        return [`${getWeek(day, true)}`, `${month}-${date}`];
      }
    },
    // 通过天气判断显示的图片并返回路径
    getImgByWeather(weather) {
      let img = '';
      if (weather == '晴') img = 'wi-day-sunny';
      else if (weather == '多云') img = 'wi-cloudy';
      else if (weather == '小雨' || weather == '中雨' || weather == '阵雨') img = 'wi-showers';
      else if (weather == '暴雨' || weather == '大雨') img = 'wi-rain-mix';
      else if (weather == '阴') img = 'wi-cloud';
      else if (weather == '雨夹雪') img = 'wi-sleet';
      else if (weather == '小雪' || weather == '中雪') img = 'wi-snowflake-cold';
      else if (weather == '大雪' || weather == '暴雪') img = 'wi-snowflake-cold';
      else img = 'wi-day-sunny';
      return img;
    },
    onConfigurationChange() {
      this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
    },
    getDynamicWeather() {
      let params = {
        url:
          `https://devapi.qweather.com/v7/weather/now?location=` +
          this.headerLon +
          ',' +
          this.headerLat +
          `&key=0a93d2ba25c2485ba4602978df50f75a`,
        method: 'GET',
      };

      this.axios(params).then(res => {
        this.humidity = res.data.now.humidity;
        this.temperature = res.data.now.temp;
      });

      let hourUrl = `https://api.caiyunapp.com/v2.6/N37HqKfCQajpg5mY/${this.headerLon},${this.headerLat}/hourly?hourlysteps=1`;
      setTimeout(() => {
        jsonp(hourUrl, (err, res) => {
          if (!err) {
            const { precipitation, temperature, wind, skycon, humidity, air_quality } = res.result.hourly;
            this.rainfall = precipitation[0].value; //降雨
            this.windpower = wind[0].speed; //风力
            this.weatherIcon = skycon[0].value; //天气
          }
        });
      }, 200);
    },
    getDynamicDayWeather() {
      let dayUrl = `https://api.caiyunapp.com/v2.6/N37HqKfCQajpg5mY/${this.headerLon},${this.headerLat}/daily?dailysteps=1`;

      setTimeout(() => {
        jsonp(dayUrl, (err, res) => {
          if (!err) {
            const { ultraviolet } = res.result.daily.life_index;
            this.ultraviolet = ultraviolet[0].index;
          }
        });
      }, 500);
    },
    getAdcodeByCityName(cityName) {
      if (!adcode || !Array.isArray(adcode)) {
        return null;
      }
      const normalizedCityName = cityName.replace(/省|市|区|县/g, '').trim();
      const matchedCity = adcode.find(item => {
        const normalizedItemName = item.name.replace(/省|市|区|县/g, '').trim();
        return (
          normalizedItemName.includes(normalizedCityName) || normalizedCityName.includes(normalizedItemName)
        );
      });

      if (matchedCity) {
        return matchedCity.adcode;
      } else {
        return null;
      }
    },
    getWeeklyWeather() {
      const adcode = this.getAdcodeByCityName(this.cityName);
      if (!adcode) {
        return;
      }
      this.forecasts = [];

      let weekly = `https://restapi.amap.com/v3/weather/weatherInfo?city=${adcode}&key=fabd72aad77a70e89c255d26a9f730b2&extensions=all`;

      jsonp(weekly, (err, res) => {
        if (!err) {
          let weather = [];
          let alldata = res.forecasts[0];
          res.forecasts[0].casts.forEach(item => {
            weather.push({
              date: item.date,
              weather: item.dayweather,
              maxTmp: item.daytemp,
              minTmp: item.nighttemp,
            });
          });
          this.forecasts = weather;
        }
      });
    },
    getHeaderInfopStyle(fs = 14, pt = 0) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    getWidthStyle(fs = 14) {
      return {
        fontSize: this.$w_Ratio(fs + this.getShowfontSizeBase(), this.$store) + 'px',
      };
    },
    getStyleContainerStyle() {
      return {
        height: this.$h_Ratio(this.style.height, this.$store) + 'px',
        backgroundColor: this.style.backgroundColor,
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
    autoGetTime() {
      let padaDate = function (value) {
        // 时间不足十补零
        return value < 10 ? '0' + value : value;
      };
      setInterval(() => {
        const date = new Date();
        // console.log(date);
        const year = date.getFullYear(); //存储年
        const month = padaDate(date.getMonth() + 1); //存储月份
        const day = padaDate(date.getDate()); //存储日期
        const hours = padaDate(date.getHours()); //存储时
        const minutes = padaDate(date.getMinutes()); //存储分
        const seconds = padaDate(date.getSeconds()); //存储秒
        //返回格式化后的日期
        this.dateString = year + 'D' + month + 'D' + day;
        this.timeString = hours + 'T' + minutes + 'T' + seconds;
      }, 1000);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let source = [];
      let WeatherData = [];
      let seriesList = [];
      let WeatherTheDay = [];

      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        WeatherTheDay = ParamData?.WeatherTheDay; // 当天天气
      }

      source.forEach(item => {
        WeatherData.push({
          date: item.date, // 时间
          weather: item.weather, // 天气
          maxTmp: item.maxTmp, // 最高温度
          minTmp: item.minTmp, // 最低温度
        });
      });

      this.forecasts = WeatherData;
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          this.setEchartsOptions(data);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setInterval(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();

          this.setEchartsOptions(res);
          // this.loading.close();
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        // this.loading.close();
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          this.axios({
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          })
            // let param = {
            //   method: ChartsData.apiData.apiUrlMethod,
            //   url: ChartsData.apiData.apiUrl,
            //   params: this.params,
            //   headers: header,
            // };

            // request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
    }),
    cityNameCopy() {
      return this.Configuration.propertyData.cityName.value;
    },
  },
  Configuration: {
    componentTitle: '动态天气',
    componentName: 'Others19Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others19Charts.png',
    id: '',
    style: {
      width: 810,
      height: 440,
      left: 0,
      top: 0,
    },
    propertyData: {
      cityName: {
        propertyComponentName: 'SingleInputor',
        value: '杭州',
        lable: '定位城市',
      },
      headerBackgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        value: 'rgba(0, 0, 0, 0.6)',
        lable: '头部背景颜色',
      },
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts0Border',
        },
      },
      headerLngLatData: {
        propertyComponentName: 'MapLatLon',
        value: {
          lon: '120.15',
          lat: '30.28',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      menuStyle: {
        value: {
          height: 85,
          width: 700,
        },
      },

      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      showStatus: {
        value: 'norm',
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import url('../../../assets/css/weather-icons.min.css');
@import url('../../../assets/css/weather-icons-wind.min.css');
.Others19Charts {
  width: 100%;
  height: 100%;
  color: #7eb3e5;
  display: flex;
  padding: 10px 0 10px 0;

  .weather-left {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .w-l-top {
      height: 6%;
      display: flex;
      justify-content: space-around;
      color: #fff;
      .weather {
        .img {
          // margin-top: 40px;
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      .temperature {
        color: #fff;
        text-align: left;

        .tmp-num {
          height: 100%;
          // margin-top: 40px;
          font-size: 60px;
          color: #fff;
          width: 100%;
          display: flex;
          align-items: center;

          span {
            font-size: 40px;
          }
        }
      }

      div {
        // margin-left: 20px;
      }
    }
    .w-l-middle {
      height: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .weather {
        display: flex;
        justify-content: center;
        height: 100%;
        width: 46%;
        .img {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      .tmp-num {
        height: 100%;
        font-size: 60px;
        color: #fff;
        width: 38%;
        display: flex;
        align-items: center;

        span {
          font-size: 40px;
        }
      }
    }

    .w-l-bottom {
      height: 40%;

      .border {
        width: 100%;
        height: 2px;
        background: radial-gradient(circle, #8b201c, transparent);
      }

      .content {
        padding: 0 20px;
        height: 100%;
        display: flex;
        justify-content: space-around;

        // border-top: 4px solid #000;
        // border-bottom: 4px solid #000;
        .air {
          .data {
            span {
              &:nth-child(2) {
                font-size: 12px;
              }
            }
          }
        }

        .flex {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .data {
            color: #fff;
            margin-top: 8px;
          }
        }
      }

      // border-image: radial-gradient(circle,#214569 80%, transparent 20%);
    }
  }

  .weather-right {
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4.6%;

    .seven-forecast {
      width: 100%;
      flex: 1;
      /* height: 18%; */
      min-height: 64px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      padding: 10px 0;
      background: url('../../../assets/img/weather/weather_bg1.png') no-repeat;
      background-size: 100% 100%;

      // min-height: 84px;
      // background: linear-gradient(30deg,#a6adb2,#010407);
      // margin-top: 10px;
      &:nth-child(1) {
        // margin-top: 0;
      }

      .bg-img {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;

        img {
          // width: 100%;
          // height: 100%;
        }
      }

      .s-f-left {
        width: 33.33%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 2;

        // margin: 10px 0;
        .date {
          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: left;

          .d-top {
            margin-bottom: 8px;
            letter-spacing: 4px;
            word-spacing: 2px;
          }

          .d-bottom {
            font-size: 12px;
          }
        }
      }
      .s-f-center {
        width: 33.33%;
        .weather-img {
          margin-left: 20%;
        }
      }

      .s-f-right {
        width: 36.33%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        position: relative;
        z-index: 2;

        // margin: 10px 0;
        .tmp-max-min {
          font-size: 12px;
          margin-top: 8px;
        }
        .weather-name {
          letter-spacing: 4px;
          word-spacing: 2px;
        }
      }
    }
  }
  .weather-icon-animate {
    display: inline-block;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  .wi-day-sunny {
    animation-name: sunnyAnimate;
    animation-duration: 8s;
    animation-iteration-count: infinite; // 无限循环
    animation-timing-function: linear; // 线性缓动（关键！确保速度均匀）
  }

  @keyframes sunnyAnimate {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(90deg); // 25%时间点对应90度（360°×25%）
    }
    50% {
      transform: rotate(180deg); // 50%时间点对应180度（360°×50%）
    }
    75% {
      transform: rotate(270deg); // 75%时间点对应270度（360°×75%）
    }
    100% {
      transform: rotate(360deg); // 100%时间点回到360度（即0度）
    }
  }

  /* // 多云（wi-cloudy）：左右浮动 */
  .wi-cloudy {
    animation-name: cloudAnimate;
  }
  @keyframes cloudAnimate {
    0% {
      transform: translateX(-5%);
    }
    50% {
      transform: translateX(5%);
    }
    100% {
      transform: translateX(-5%);
    }
  }

  /* // 阵雨/小雨（wi-showers）：下落+淡入淡出 */
  .wi-showers {
    animation-name: rainAnimate;
  }
  .wi-sleet {
    animation-name: rainAnimate;
  }

  @keyframes rainAnimate {
    0% {
      transform: translateY(-10%);
      opacity: 0.8;
    }
    50% {
      transform: translateY(10%);
      opacity: 0.4;
    }
    100% {
      transform: translateY(-10%);
      opacity: 0.8;
    }
  }
}

.title {
  font-size: 14px;
}

.V8Style {
  .weather-left {
    color: #000 !important;
  }

  .seven-forecast {
    color: #000 !important;
  }

  .data {
    color: #000 !important;
  }
}

.v2-style {
  z-index: 99;
  // position: absolute;
  // top: 0;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  // transform: scale(0.3);
  justify-content: space-between;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.39) 45%, transparent 100%);

  // background-color: rgb(14, 33, 73);
  .header-left {
    max-width: 460px;
    width: 30%;
    height: 100%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-left-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33.33%;
        height: 100%;
      }
    }
  }

  .header-middle {
    .header-middle-filter {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 85%;

      background: -moz-linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
      background: -o-linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
      background: -ms-linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
      background: linear-gradient(
        to left,
        rgba(1, 114, 180, 0),
        rgba(0, 84, 241, 0.1),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.2),
        rgba(0, 84, 241, 0.1),
        rgba(0, 41, 221, 0)
      );
    }

    width: 30.5%;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    flex-shrink: 1;
    overflow: hidden;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-ProjectName {
      width: 100%;
      height: 100%;
      position: absolute;
      color: transparent;

      background-image: -moz-linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);
      background-image: -o-linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);
      background-image: -ms-linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);
      background-image: linear-gradient(180deg, #ffffff, #ffffff, #c3c8cc, #929ba3);

      -webkit-background-clip: text;
      -webkit-text-stroke: 0.5px rgb(0, 0, 0);
      font-weight: 700;
      top: 0;
      display: flex;
      justify-content: center;

      p {
        margin: 0;
      }
    }

    .spotlight-ct {
      position: absolute;
      bottom: -5%;
      left: 50%;
      transform: translateX(-49.5%);
      width: 70%;
      height: 30%;
      overflow: hidden;

      // background-color: rgba(204, 204, 204, 0.308);
      .spotLight1 {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 28%;
        height: 20%;
        transform: translate(-50%, -50%);
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #00eee2 12%,
          #befdff 12%,
          #00eee2 12%,
          rgba(189, 91, 87, 0) 60%,
          rgba(189, 91, 87, 0) 69%
        );
        animation: titlelight 4s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      .spotLight2 {
        background: radial-gradient(
          ellipse at center,
          rgba(189, 91, 87, 0) 0%,
          #00eee2 9%,
          rgb(198, 255, 252) 9%,
          rgb(0, 238, 226) 9%,
          rgba(189, 91, 87, 0) 75%,
          rgba(189, 91, 87, 0) 73%
        );

        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 11%;
        height: 14%;
        transform: translate(-50%, -50%);
        animation: titlelight 4s infinite cubic-bezier(0.74, 0.57, 0.5, 0.9);
      }

      @keyframes titlelight {
        0% {
          left: -40%;
          opacity: 1;
          transform: scale(1.2, 1.3) translate(-50%, -50%);
        }

        35% {
          opacity: 0.7;
          transform: scale(1.6, 1.5) translate(-50%, -50%);
        }

        50% {
          opacity: 1;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        75% {
          opacity: 0.5;
          transform: scale(1.5, 1.5) translate(-50%, -50%);
        }

        100% {
          left: 120%;
          opacity: 1;
          transform: scale(1.2, 1.2) translate(-50%, -50%);
        }
      }
    }
  }

  .header-right {
    max-width: 520px;
    width: 40%;
    height: 100%;
    position: relative;

    .header-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }

    .header-right-show-infos {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      display: flex;

      .info-item0 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        height: 100%;
        color: #95ccff;
      }

      .info-item1 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30%;
        height: 100%;
        color: #95ccff;
      }

      .info-item2 {
        display: flex;
        //align-items: center;
        justify-content: center;
        align-self: center;
        width: 30%;
        height: 80%;

        .info-item2-wrapper {
          width: 100%;
          height: 80%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .info-item2-hour {
          margin-left: 60%;
          display: flex;
          height: 34%;
          width: 60%;

          div {
            height: 100%;
            width: 8%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        .info-item2-date {
          margin-top: 3%;
          margin-left: 33%;
          display: flex;
          height: 20%;
          width: 70%;

          div {
            height: 100%;
            width: 8%;

            img {
              height: 100%;
              width: 100%;
              margin: 0;
              padding: 0;
            }
          }
        }

        p {
          margin: 0;
          padding: 0;
        }
      }

      .info-item3 {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20%;
        height: 100%;
      }
    }
  }
}
</style>
